import { Enum } from '../commons/common';

/** سمت گزارش: واریز یا برداشت؛ باید با ExchangeHistoryType سمت بک‌اند یکی بماند. */
export enum KuCoinHistoryType {
    Deposit = 1,
    Withdrawal = 2,
}

export interface KuCoinHistory {
    id: string;
    createTime: string;
    network: string;
    asset: string;
    quantity: number;
    fee: number;
    txid: string | null;
    address: string | null;
    type: Enum;
    status: string;
    failureReason?: string | null;
    transaction: {
        trackingCode: string;
        amount: number;
        createdBy: {
            firstName: string;
            lastName: string;
            userName: string;
            id: string;
            fullName: string;
        };
        createdOn: string;
        network: {
            name: string;
            fee: number;
            network: string;
        };
        description: string;
        state: Enum;
        modifiedBy: string;
        txId: string;
    } | null;
}
